module.exports = __webpack_public_path__ + "static/media/DIBATALKAN.43efb8ab.jpg";